// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"1c2bac78","670":"f0eb02eb"}[chunkId] + ".chunk.js";
};